import { createAction } from 'typesafe-actions';

import * as ActionTypes from './actionTypes';
import { EnvironmentConfig } from './reducer';

export const initEnvironment = createAction(
  ActionTypes.INIT_ENVIROMENT,
  action => (env: EnvironmentConfig) => action(env),
);
